var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSmallTriangelBlack = function SvgSmallTriangelBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 8,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.333 4-4-3.464v6.928l4-3.464Z",
    fill: "#17181D"
  })));
};
export { SvgSmallTriangelBlack as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgNSA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNC4zMzM1IDRMMC4zMzM0OTYgMC41MzU4OTdMMC4zMzM0OTYgNy40NjQxTDQuMzMzNSA0WiIgZmlsbD0iIzE3MTgxRCIvPgo8L3N2Zz4K";